module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8638/img/design-manager.svg"